export default __webpack_public_path__ + "static/ds_02-6fc6ac8eb0dc325ec9fbf341401c68b7.png";